import { Locale } from './user';

export const Device = {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    DESKTOP: 'desktop',
};

export const TokenType = {
    PUBLIC: 'PUBLIC',
    CAR: 'CAR',
    GENERAL: 'GENERAL',
};

export const DotCMSLanguageId = {
    EN: '1',
    ES: __FCO_DOTCMS_LANGUAGE_ID_SPANISH__,
};

export const dotCMSLanguageIdByLocale = {
    [Locale.EN]: DotCMSLanguageId.EN,
    [Locale.ES]: DotCMSLanguageId.ES,
};
